import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
    HardwareReservation,
    HardwareReservationParams, HardwareReservationProject,
} from '@app/interfaces/reservation/hardware-reservation';
import { environment } from '@env/environment';
import { lastValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class HardwareReservationService {
    private baseUrl = environment.api.services.reservation + '/hardware-reservation';

    constructor(private http: HttpClient) {
    }

    async findHardwareList(data: HardwareReservationParams): Promise<HardwareReservation[]> {
        return lastValueFrom(this.http.post<HardwareReservation[]>(`${this.baseUrl}/hardware/list`, data));
    }
}
